import { RiBrainLine } from "react-icons/ri";
import useServiceStatus from "../../../hooks/useServiceStatus";
import { useDispatch } from "react-redux";
import { openSideMenu } from "../../../redux/ui/uiSlice";
import { useState } from "react";
import ActivateBotServiceModal from "../ActivateBotServiceModal";
import RequestBacktestMenu from "./RequestBacktestMenu";
import { FiLock } from "react-icons/fi";

function RequestBacktest({ className, title, targetBot, closeModal }) {
  const { isActive: isBotServiceActive } = useServiceStatus("bot");
  const [showServiceActivationModal, setShowServiceActivationModal] =
    useState(false);

  const dispatch = useDispatch();

  const clickHandler = () => {
    if (isBotServiceActive) {
      dispatch(openSideMenu("request-backtest", "request-backtest"));
    } else {
      setShowServiceActivationModal(true);
    }
  };

  return (
    <>
      <span className={className} onClick={clickHandler}>
        {isBotServiceActive ? <RiBrainLine /> : <FiLock />}
        {title || "Request Backtest"}
      </span>

      {showServiceActivationModal && (
        <ActivateBotServiceModal
          setShowActivationModal={setShowServiceActivationModal}
          showActivationModal={showServiceActivationModal}
        />
      )}

      <RequestBacktestMenu bot={targetBot} closeHandler={closeModal} />
    </>
  );
}

export default RequestBacktest;
